import script from "./SynonymsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./SynonymsPage.vue?vue&type=script&setup=true&lang=js"

import "./SynonymsPage.vue?vue&type=style&index=0&id=711be119&lang=less&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-711be119"]])

export default __exports__